// extracted by mini-css-extract-plugin
export default {"authContainer":"index_authContainer__xNLLk","dialogRoot":"index_dialogRoot__NzQq7"};